import CmsPage from './cms.page';

export default class CmsDesktopPage extends CmsPage {

}
